import styled from 'styled-components';

export const StyledRadio = styled.input`
  margin-right: 5px;
  appearance: none;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.disable};
  border-radius: 50%;
  outline: none;
  cursor: pointer;

  &:checked {
    background-color: ${({ theme }) => theme.colors.disable};
  }

  &:checked::after {
    content: '';
    display: block;
    width: 12px;
    height: 12px;
    margin: 2px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.secondary};
  }
`;

export const Label = styled.label`
  color: ${({ theme }) => theme.colors.black};
  display: flex;
  align-items: center;
  justify-content: center;
`;
